import { Facebook } from "lucide-react";
import { CONTACT, NAV_LINKS } from "@/data/siteData";

export default function Footer() {
  return (
    <footer data-testid="footer" className="noise-navy text-[#F8FAFC] border-t-4 border-[#FACC15]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="Logo SMP Wichniarek" className="h-14 w-14 object-contain" />
            <div className="leading-tight">
              <span className="block font-display font-black uppercase tracking-tight text-lg">SMP Wichniarek</span>
              <span className="block font-accent text-[10px] uppercase tracking-widest text-blue-200">Szkółka Młodego Piłkarza</span>
            </div>
          </div>
          <p className="mt-5 text-sm text-blue-200 font-medium leading-relaxed">
            {CONTACT.name}
            <br />
            {CONTACT.address}
            <br />
            NIP: {CONTACT.nip}
          </p>
        </div>
        <div>
          <h4 className="font-accent text-xs font-bold uppercase tracking-[0.3em] text-[#FACC15]">Menu</h4>
          <nav className="mt-5 flex flex-col gap-2">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`footer-link-${l.href.replace('#', '')}`}
                className="text-sm font-medium text-blue-100 hover:text-[#FACC15] transition-colors duration-200"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
        <div>
          <h4 className="font-accent text-xs font-bold uppercase tracking-[0.3em] text-[#FACC15]">Kontakt</h4>
          <div className="mt-5 space-y-2 text-sm font-medium text-blue-100">
            <p>{CONTACT.phone}</p>
            <p>{CONTACT.email}</p>
            <a
              href={CONTACT.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook-link"
              className="inline-flex items-center gap-2 mt-3 text-blue-100 hover:text-[#FACC15] transition-colors duration-200"
            >
              <Facebook size={16} /> facebook.com/szkolkawichniarek
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-blue-800 py-5 text-center font-accent text-xs uppercase tracking-widest text-blue-300">
        © {new Date().getFullYear()} SMP Wichniarek • Szkółka Młodego Piłkarza
      </div>
    </footer>
  );
}
